import Vue from "vue";
import Vuex from "vuex";
import createBookingModule from "./create-booking";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { createBookingModule }
});
